import _ from 'underscore';
import { projectionGridScopeNavigator } from '@bingads-webui-campaign/projection-grid-scope-navigator';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';

const { noop } = _;

export const getAdditionalPlugins = ({
  toolbarPlugin,
  scope,
  i18n,
  reportName,
}) => (view) => {
  let isTimeGrid = false;
  if (reportName.indexOf('Time') !== -1) {
    isTimeGrid = true;
  }

  return [
    toolbarPlugin,
    {
      plugin: projectionGridScopeNavigator,
      config: scope,
    }, {
      plugin: placeholderPlugin,
      config: {
        container: '.dimensions-page .grid-noresult',
        text: isTimeGrid ? i18n.getString('Dimension_GridNoData') : i18n.getString('Grid_NoRecords'),
        filteredContainer: '.dimensions-page .grid-noresult',
        filteredEmptyText: i18n.getString('Grid_NoFilteredRecords'),
        get asyncEmptyText() {
          return view.tooMuchDataDownloadErrorText;
        },
        asyncCallback: () => Promise.resolve(view.showTooMuchDataError),
      },
    }, {
      plugin: definePlugin => definePlugin('filter', [], noop),
    }, {
      plugin: definePlugin => definePlugin('filterState', [], noop),
    },
  ];
};
